<template>
  <DataTable
    data-testid="stock-lending-table"
    class="stock-lending-table"
    :data="items"
    :items-per-page="itemsPerPage"
    :status="tableCurrentStatus"
    :columns="columns"
    has-interaction
    @on-row-click="handleOnRowClick"
  />
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { InstrumentNameCell } from '@/modules/trade/components/InstrumentNameCell';
import { InstrumentPriceCell } from '@/modules/trade/components/InstrumentPriceCell';

import { DataTable } from '@warrenbrasil/nebraska-web';
import { StockLendingPosition } from '@/modules/trade/services/instruments';
import { columns } from './columns';

@Component({
  components: {
    DataTable,
    InstrumentNameCell,
    InstrumentPriceCell
  }
})
export default class StockLendingTable extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: StockLendingPosition[];

  @Prop({ type: Number, required: true })
  readonly itemsPerPage!: number;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  readonly columns = columns;

  get tableCurrentStatus() {
    return this.isLoading ? 'loading' : 'default';
  }

  handleOnRowClick({ symbol }: StockLendingPosition) {
    this.$router.push({
      name: 'tradeInstrument',
      params: { ticker: symbol }
    });
  }
}
</script>

<style lang="less" scoped>
.stock-lending-table {
  padding: @size-spacing-x500;
  border: @size-border-x400 solid @divider-primary;
  border-radius: @size-radius-x200;

  /deep/ th {
    white-space: nowrap;
  }

  /deep/ td:not(:first-child) {
    white-space: nowrap;
  }

  &__helper {
    padding: @size-spacing-x700 0 @size-spacing-x500 0;
    margin: 0 auto;
  }
}
</style>
